import React from 'react'
import Section from '../components/Section'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'
import Dropdown from 'react-bootstrap/Dropdown'
import '../assets/styles/checkout-process.css'

class Cart extends React.Component {
	state = {
		shoppingCartItems: [
			{
				title: 'Print Ethno Tank',
				sku: '7165370020001',
				desc:
					'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
				price: 59.99,
				color: 'black',
				size: 'small',
				quantity: 2,
				image: 'https://placehold.it/200'
			},
			{
				title: 'Twill Summer Floral Shorts',
				sku: '7165370020001',
				desc:
					'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
				price: 29.99,
				color: 'pink',
				size: 'medium',
				quantity: 1,
				image: 'https://placehold.it/200'
			},
			{
				title: 'Wave Gloss Purse',
				sku: '7165370020001',
				desc:
					'Lorem ipsum dolor sit amet consectetur adipisicing elit. Reiciendis commodi esse nisi nobis deleniti ipsum? Eius similique vel perferendis minus.',
				price: 129.99,
				color: 'black mix',
				size: 'one size',
				quantity: 1,
				image: 'https://placehold.it/200'
			}
		]
	}

	componentDidMount() {
		document.querySelector('#sticky .col-md-10').style.display = 'none'
		document.querySelector('#sticky .col-md-2').style.display = 'none'
	}

	updateQuantity = (integer, key) => {
		let newQuantity = this.state.shoppingCartItems[key].quantity + integer
		this.setState(state => {
			const updatedState = state.shoppingCartItems.map((item, j) => {
				if (j === key) {
					return (item.quantity = newQuantity)
				} else {
					return item
				}
			})
			return {
				updatedState
			}
		})
	}

	render() {
		return (
			<div className='main-container'>
				<Section className='height-auto'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-12 text-center'>
								<h2>Shopping Bag</h2>
							</div>
						</div>
					</div>
				</Section>

				<section id='cart-items__section'>
					<div className='container'>
						<div className='row'>
							<div className='col-md-3'>{/* spacer */}</div>
							<div className='col-md-4'>
								<h4 className=''>Product Info</h4>
							</div>
							<div className='col-md-4'>
								<h4 className=' text-right'>Price</h4>
							</div>
						</div>
						{this.state.shoppingCartItems.map((item, i) => {
							return (
								<div className='row cart-item' key={i}>
									<div className='col-md-3'>
										<img
											src={item.image}
											alt='placeholder'
										/>
									</div>
									<div className='col-md-3'>
										<h4 className=''>{item.title}</h4>
										<p className=''>#{item.sku}</p>
										<div className='item-info'>
											<span className='item-info__detail'>
												<FAI icon='tint' />
												&ensp;
												<Dropdown
													onSelect={(key, e) => {
														document.querySelector(
															'#color-dropdown'
														).innerText =
															e.currentTarget.innerText
													}}>
													<Dropdown.Toggle
														variant=''
														id='color-dropdown'>
														{item.color}
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Dropdown.Item>
															Maroon
														</Dropdown.Item>
														<Dropdown.Item>
															Pink
														</Dropdown.Item>
														<Dropdown.Item>
															Black
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</span>
											<span className='item-info__detail'>
												<FAI icon='tshirt' />
												&ensp;
												<Dropdown
													onSelect={(key, e) => {
														document.querySelector(
															'#size-dropdown'
														).innerText =
															e.currentTarget.innerText
													}}>
													<Dropdown.Toggle
														variant=''
														id='size-dropdown'>
														{item.size}
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Dropdown.Item>
															x-small
														</Dropdown.Item>
														<Dropdown.Item>
															small
														</Dropdown.Item>
														<Dropdown.Item>
															medium
														</Dropdown.Item>
														<Dropdown.Item>
															large
														</Dropdown.Item>
														<Dropdown.Item>
															x-large
														</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown>
											</span>
											<span className='item-info__detail'>
												<FAI icon='shopping-bag' />
												&ensp;
												<span
													onClick={() => {
														this.updateQuantity(
															-1,
															i
														)
													}}
													style={{
														cursor: 'pointer'
													}}>
													-&nbsp;
												</span>
												<span>{item.quantity}</span>
												<span
													onClick={() => {
														this.updateQuantity(
															1,
															i
														)
													}}
													style={{
														cursor: 'pointer'
													}}>
													&nbsp;+
												</span>
											</span>
										</div>
									</div>
									<div className='col-md-3'>
										<p>{item.desc}</p>
									</div>
									<div className='col-md-3 text-right'>
										<h4>${item.price * item.quantity}</h4>
									</div>
								</div>
							)
						})}
					</div>
				</section>

				<Section id='proceed__section'>
					<div className='col-md-12 text-right'>
						<div className='row active-pink-2'>
							<span className='col-md-4' />
							<div className='form-group col-md-12'>
								<div className='row justify-content-end'>
									<input
										type='email'
										name='guestCheckout'
										id='guestCheckout'
										className='col-md-4'
										placeholder='Your Email'
										data-op-id='0'
										style={{ minHeight: '4.7rem' }}
									/>
									<a
										href='/shipping'
										className='btn'
										style={{
											marginLeft: '2.4rem'
										}}>
										<span className='btn__text'>
											Proceed as Guest
										</span>
									</a>
									<a
										href='/login'
										className='btn btn--primary'>
										<span className='btn__text'>
											Proceed with Account
										</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</Section>

				<Section id='related-items__section'>
					<div className='col-12 text-center'>
						<h4 className=' type--uppercase'>You May Also Like</h4>
						<hr className='center' />
					</div>
					<div className='col-md-3 text-center'>
						<a href='/'>
							<img
								src='https://placehold.it/300'
								alt='placeholder'
							/>
							<h4 className=''>Ethno Print Skirt</h4>
						</a>
					</div>
					<div className='col-md-3 text-center'>
						<a href='/'>
							<img
								src='https://placehold.it/300'
								alt='placeholder'
							/>
							<h4 className=''>Washwell Destructed Jeans</h4>
						</a>
					</div>
					<div className='col-md-3 text-center'>
						<a href='/'>
							<img
								src='https://placehold.it/300'
								alt='placeholder'
							/>
							<h4 className=''>Suit Case Bag</h4>
						</a>
					</div>
					<div className='col-md-3 text-center'>
						<a href='/'>
							<img
								src='https://placehold.it/300'
								alt='placeholder'
							/>
							<h4 className=''>French Beret</h4>
						</a>
					</div>
				</Section>
			</div>
		)
	}
}

export default Cart
